<h2 mat-dialog-title>{{ data.status }}</h2>

<div mat-dialog-content>
  <div class="tw:text-[13px] tw:font-semibold tw:text-[#333] tw:mb-3">{{ data.studentName }}</div>

  @if (needsReason) {
    <div class="tw:w-full">
      <label class="field__label">Reason</label>
      <select class="field__control tw:w-full" [(ngModel)]="reason" required>
        <option value="">-- Select --</option>
        @for (r of reasons; track r) {
          <option [value]="r">{{ r }}</option>
        }
      </select>
      <span class="field__hint tw:text-[#c00] tw:text-[10px] tw:font-semibold">* required</span>
    </div>
  }

  <label class="field__label">Comments</label>
  <textarea class="field__control tw:w-full" [(ngModel)]="comments" rows="4"
    [placeholder]="needsComments ? 'Add a comment…' : 'Add a comment (optional)'"></textarea>
  @if (needsComments) {
    <span class="field__hint tw:text-[#c00] tw:text-[10px] tw:font-semibold">* required</span>
  }

  @if (needsSpoken) {
    <div class="tw:mb-3">
      <div class="tw:text-[13px] tw:text-[#333] tw:mb-2">
        I have spoken to the Parent / carer
        <span class="tw:text-[#c00] tw:text-[10px] tw:font-semibold"> * required</span>
      </div>
      <div class="tw:flex tw:gap-3">
        <label class="field__radio"><input type="radio" name="parentCarerInformed" value="yes" [(ngModel)]="parentCarerInformed" /> Yes</label>
        <label class="field__radio"><input type="radio" name="parentCarerInformed" value="no" [(ngModel)]="parentCarerInformed" /> No</label>
      </div>
    </div>
  }
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!isValid" (click)="save()">Save</button>
</div>
